import { customAxios } from '../../common/customAxios';
import { myOwnTractorsApiUrl } from '../queries/getMyOwnTractors';

interface postMyOwnTractorsParams {
  reqBody: {
    brandId: string;
    model: string;
    engineOutputInPs: number;
    manufacturedYear: number;
    operationTime: number;
    marketPrice: number | null;
  };
}

export const postMyOwnTractors = ({ reqBody }: postMyOwnTractorsParams): Promise<{ id: string }> => {
  return customAxios.post(myOwnTractorsApiUrl, reqBody);
};
